import { map as createMap, tileLayer, marker, divIcon } from 'leaflet'
import 'leaflet/dist/leaflet.css'

const PIN = '<svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.59341 19.6825L8.125 20L7.65659 19.6825L7.64783 19.6769C7.64333 19.6739 7.63711 19.6691 7.62923 19.6637C7.62113 19.6581 7.61135 19.651 7.59989 19.6428L7.55837 19.6132C7.50091 19.5727 7.41903 19.515 7.31732 19.4402C7.10888 19.2869 6.81407 19.0633 6.46148 18.7775C5.75693 18.2063 4.81532 17.3803 3.87098 16.3655C2.01607 14.3724 0.000209546 11.4887 0 8.26575C0 6.07557 0.855104 3.97345 2.37818 2.42297C3.90144 0.87243 5.96833 0 8.125 0C10.2817 0 12.3486 0.872429 13.8718 2.42297C15.3949 3.97345 16.25 6.07557 16.25 8.26575C16.2498 11.4887 14.2339 14.3724 12.379 16.3655C11.4347 17.3803 10.4931 18.2063 9.78852 18.7775C9.43593 19.0633 9.14112 19.2869 8.93268 19.4402C8.83128 19.5147 8.74968 19.5723 8.69225 19.6128L8.6501 19.6428C8.63864 19.651 8.62887 19.6581 8.62077 19.6637C8.61645 19.6667 8.61262 19.6694 8.60931 19.6718C8.60658 19.6738 8.61134 19.6704 8.60931 19.6718L8.59341 19.6825ZM8.125 11.5871C9.93559 11.5871 11.3938 10.0944 11.394 8.26575C11.394 6.4369 9.93575 4.9433 8.125 4.9433C6.31425 4.9433 4.85596 6.4369 4.85596 8.26575C4.85622 10.0944 6.31441 11.5871 8.125 11.5871Z" fill="#D91F26"/></svg>'

export default class ContactsMap {
    constructor() {
        this.map = null
    }

    init() {
        const mapElement = document.getElementById('contacts-map')
        if (!mapElement) return

        const lat = parseFloat(mapElement.dataset.lat)
        const lng = parseFloat(mapElement.dataset.lng)
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
            console.warn('[contacts-map] lat/lng mancanti o non valide')
            return
        }

        this.map = createMap(mapElement, {
            scrollWheelZoom: false,
        }).setView([lat, lng], 16)

        this.map.zoomControl.setPosition('bottomright')

        tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }).addTo(this.map)

        marker([lat, lng], {
            icon: divIcon({
                className: 'map-pin',
                html: PIN,
                iconSize: [17, 20],
                iconAnchor: [8, 20],
            }),
            interactive: false,
        }).addTo(this.map)

        // Il contenitore può essere misurato prima del layout finale: forza il ricalcolo.
        setTimeout(() => this.map.invalidateSize(), 200)
    }
}
